import React from 'react';
import { MessageCircle, Mail, Clock } from 'lucide-react';
export function Footer() {
  return <footer id="contacto" className="bg-[#050608] pt-20 pb-10 px-6 border-t border-white/5" data-id="element-67">
      <div className="max-w-7xl mx-auto" data-id="element-68">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-69">
          <div className="lg:col-span-2" data-id="element-70">
            <img src="https://cdn.magicpatterns.com/uploads/hdwTRmatKyUZFdT516kJwa/Logo_sin_fondo.png" alt="Krove Latam Logo" className="h-24 md:h-28 object-contain mb-6" data-id="element-71" />
            <p className="text-text-secondary max-w-sm mb-8 leading-relaxed" data-id="element-72">
              Creamos Landing Pages profesionales, diseñadas específicamente
              para negocios locales, listas para conseguirte clientes desde el
              primer día.
            </p>
            <p className="text-xl font-serif font-medium text-white italic" data-id="element-73">
              "Porque tu negocio merece ser visto."
            </p>
          </div>

          <div data-id="element-74">
            <h4 className="text-white font-medium mb-6 uppercase tracking-wider text-sm" data-id="element-75">
              Contacto Directo
            </h4>
            <ul className="space-y-4" data-id="element-76">
              <li data-id="element-77">
                <a href="https://wa.me/573135250384" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-text-secondary hover:text-white transition-colors group" data-id="element-78">
                  <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center group-hover:bg-[#25D366]/20 group-hover:text-[#25D366] transition-colors" data-id="element-79">
                    <MessageCircle className="w-5 h-5" data-id="element-80" />
                  </div>
                  <span data-id="element-81">+57 313 525 0384</span>
                </a>
              </li>
              <li data-id="element-82">
                <a href="mailto:krove.lat@gmail.com" className="flex items-center gap-3 text-text-secondary hover:text-white transition-colors group" data-id="element-83">
                  <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center group-hover:bg-primary/20 group-hover:text-primary transition-colors" data-id="element-84">
                    <Mail className="w-5 h-5" data-id="element-85" />
                  </div>
                  <span data-id="element-86">krove.lat@gmail.com</span>
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-87">
            <h4 className="text-white font-medium mb-6 uppercase tracking-wider text-sm" data-id="element-88">
              Horarios de Atención
            </h4>
            <div className="flex items-start gap-3 text-text-secondary" data-id="element-89">
              <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center shrink-0" data-id="element-90">
                <Clock className="w-5 h-5" data-id="element-91" />
              </div>
              <div className="pt-2" data-id="element-92">
                <p className="mb-1" data-id="element-93">Lunes - Sábado</p>
                <p className="text-white font-medium" data-id="element-94">9:00 AM - 6:00 PM</p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-95">
          <p className="text-text-secondary text-sm" data-id="element-96">
            © 2026 Krove Latam. Todos los derechos reservados.
          </p>
          <div className="flex gap-6 text-sm text-text-secondary" data-id="element-97">
            <a href="#" className="hover:text-white transition-colors" data-id="element-98">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-99">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}